import React, { useCallback, JSX } from 'react';
import { MpKeywordSettings, MpNewKeyword } from 'src/models/matchingProfiles/types';
import { usePrefixSearchLimit } from 'src/models/matchingProfiles/hooks';
import PlainDropDown from 'src/common/PlainDropDown';
import { IPlainDropdownValue } from 'src/common/PlainDropDown/types';
import { useApiTenders } from 'src/models/procurements/Tenders/hooks';
import { SearchLogic } from '@tendium/prom-types';

interface Props<T extends string> {
  label: string;
  selectedValue: T;
  values: IPlainDropdownValue<T>[];
  disabled?: boolean;
  keyword: MpNewKeyword;
  field: keyof MpKeywordSettings;
  className?: string;
}

export function SelectFieldQuickFilter<T extends string>(props: Props<T>): JSX.Element {
  const { values, selectedValue, label, keyword, field, disabled, className } = props;
  const prefixSearchLimit = usePrefixSearchLimit();
  const [{ vars: searchArgs }, updateSearchArgs] = useApiTenders();

  const onUpdate = useCallback(
    (val: T) => {
      const isPrefixSearchLimit =
        !!searchArgs?.keywordArgs &&
        searchArgs?.keywordArgs.filter(kwd => kwd.searchLogic === SearchLogic.PrefixMatch).length >=
          prefixSearchLimit &&
        field === 'searchLogic' &&
        val === SearchLogic.PrefixMatch;

      if (!isPrefixSearchLimit) {
        const keywordIndex = searchArgs?.keywordArgs?.findIndex(k => k === keyword);

        if (keywordIndex !== undefined && keywordIndex !== -1) {
          const updatedKeywords = [...(searchArgs?.keywordArgs || [])];
          updatedKeywords[keywordIndex] = { ...keyword, [field]: val };

          updateSearchArgs({ keywordArgs: updatedKeywords });
        }
      }
    },
    [field, keyword, prefixSearchLimit, searchArgs?.keywordArgs, updateSearchArgs]
  );

  return (
    <PlainDropDown
      values={values}
      selectedValue={selectedValue}
      label={label}
      onSelect={onUpdate}
      hideLabel
      disabled={disabled}
      className={className}
      type={'single'}
    />
  );
}

export default SelectFieldQuickFilter;
